import { InjectionToken } from '@angular/core';

export interface CoreConfiguration {
    base?: CoreConfigurationBase;
    collage?: CoreConfigurationBase;
    verity?: CoreConfigurationBase;
    cr?: CoreConfigurationBase;
}

export interface CoreConfigurationBase {
    categories?: CoreConfigurationCategories;
    extends?: string;
    overwriteSymbologies?: CoreConfigurationOverwriteSymbology[];
}

export interface CoreConfigurationCategories {
    Station?: CoreConfigurationStation;
    Target?: Target;
}

export interface CoreConfigurationStation {
    PointSymbolizer?: CoreConfigurationPointSymbolizer;
}

export interface CoreConfigurationStationSymbolizer {
    PointSymbolizer?: CoreConfigurationPointSymbolizer;
}

export interface CoreConfigurationPointSymbolizer {
    marker?: string;
    surveyMarker?: string;
    currentMarker?: string;
    surveyedCurrentMarker?: string;
    size?: number;
    billboard?: boolean;
    autoScale?: boolean;
    minScale?: number;
    selectionMarker?: string;
    stationSymbolizer?: CoreConfigurationStationSymbolizer;
    floorSymbolizer?: CoreConfigurationFloorSymbolizer;
    showLabels?: boolean;
    showDecorator?: boolean;
    color?: number[];
    labelId?: string;
    selectionColor?: number[];
    targetDecorator?: CoreConfigurationTargetDecorator;
    labelField?: string;
}

export interface CoreConfigurationFloorSymbolizer {
    PointSymbolizer?: CoreConfigurationPointSymbolizer;
}

export interface CoreConfigurationTargetDecorator {
    LineSymbolizer?: CoreConfigurationLineSymbolizer;
}

export interface CoreConfigurationLineSymbolizer {
    strokeColor?: number[];
    strokeWidth?: number;
}

export interface Target {
    PointSymbolizer?: CoreConfigurationPointSymbolizer;
}

export interface CoreConfigurationOverwriteSymbology {
    id?: string;
    layerType?: string;
    PointCloudSymbolizer?: CoreConfigurationPointCloudSymbolizer;
    category?: string;
    Symbolizer?: CoreConfigurationSymbolizer;
}

export interface CoreConfigurationPointCloudSymbolizer {
    alpha?: number;
    drawingRule?: string;
    fixedColor?: string;
}

export interface CoreConfigurationSymbolizer {
    RuleSymbolizer?: CoreConfigurationRuleSymbolizer;
}

export interface CoreConfigurationRuleSymbolizer {
    version?: number;
    rules?: CoreConfigurationRule[];
}

export interface CoreConfigurationRule {
    expression?: CoreConfigurationExpression;
    PointSymbolizer?: CoreConfigurationPointSymbolizer;
    id?: string;
}

export interface CoreConfigurationExpression {
    aritmOp?: string;
    rightExp?: CoreConfigurationExpression;
    leftExp?: CoreConfigurationExpression;
    logicOp?: string;
    constant?: boolean | number | string;
    field?: string;
}

export const CORE_CONFIGURATION_TOKEN = new InjectionToken<CoreConfiguration>('CORE_CONFIGURATION_TOKEN');
